import DashboardTile from './DashboardTile';

export default DashboardTile;
